<template>
  <div class="oido-card">
    <slot></slot>
  </div>
</template>


<script>



export default {



}
</script>


<style scoped>
.oido-card {
  margin: 1rem 1rem;
  border-radius: 8px !important;
  box-shadow: 0 0px 21px -1px rgba(0, 0, 0, 0.06);
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
}

.oido-grid-column>.oido-card:not(:last-child) {
  flex: 0;
}


@media (max-width: 500px) {
  .oido-grid .oido-card {
    margin: 0;
    border-radius: 0px !important;
    box-shadow: none;
    box-shadow: 0 0px 5px 0px rgba(0, 0, 0, 0.1);
    margin-bottom: 3rem;
  }

  
}
</style>
<style>
@media (max-width: 500px) {

  .oido-grid{
    padding-top: 0!important;
  }
  /* .oido-grid>.oido-grid-row:first-child .oido-card:first-child {
    margin-top: -1.5rem;
  } */
  .oido-card-header {
    padding: 1.2rem 1.3rem 0.9rem 1rem !important;
    margin: 0 !important;
  }

  .oido-card-content {
    padding: 0 1rem !important;
  }

  .oido-settings-list-item {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    margin: 0 !important;
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }

  .oido-grid>.oido-grid-row {
    margin: 0 !important;
  }

  .oido-card-section-header .actions .oido-button {
    align-items: flex-end;
    margin-bottom: 0.15rem;
  }

}
</style>